import * as React from 'react';
import { PropsWithChildren, PureComponent } from 'react';

import sbSpinner from '../images/sb-spinner.gif';

type Props = {
  className: string;
  loadingImage: string;
  width: string;
};

export default class LoadingSpinner extends PureComponent<
  PropsWithChildren<Props>
> {
  static defaultProps = {
    className: '',
    loadingImage: sbSpinner,
    width: '128px',
  };

  constructor(props, context) {
    super(props, context);

    if (!this.props.loadingImage && !this.props.children) {
      throw new Error(
        'Spinner must have either a loadingImage prop or children to display.'
      );
    }
  }

  render() {
    const finalClass = `LoadingSpinner ${this.props.className}`.trim();

    const { loadingImage, width } = this.props;
    return (
      <div>
        {loadingImage && (
          <img
            alt=""
            className={finalClass}
            src={loadingImage}
            height={width}
            width={width}
          />
        )}
        {this.props.children}
      </div>
    );
  }
}
